import axios from 'axios';
import router from '../router/index';
import $ from 'jquery';
import Vue from 'vue';
import { Message } from 'element-ui';
const stands = {
    state: () => ({
        items: [],
        filter: {
            searchTerm: null,
            skip: 0,
            take: 100,
            total: 0,
            page: 1,
        },
        selectedItems: [],
        loading: true,
        saloons: [],
        standID: null,
        gallery: [],
    }),
    mutations: {
        setStands(state, payload) {
            state.items = payload.items;
            state.filter.total = payload.totalCount;
        },
        setSelectedStands(state, payload) {
            state.selectedItems = payload;
        },
        setStandPage(state, payload) {
            state.filter.page = payload;
            this.dispatch('getStands');
        },
        setStandTake(state, payload) {
            state.filter.page = 1;
            state.filter.take = payload;
            this.dispatch('getStands');
        },
    },
    actions: {
        async saveStandSaloonOrder(context, payload) {
            var res = await axios.post('/stand/UpdateOrderNosSaloons', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async saveStandOrder(context, payload) {
            var res = await axios.post('/stand/UpdateOrderNos', { ids: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
        },
        async getStand(store, payload) {
            var res = await axios.post('stand/get', { id: payload });
            return res;
        },
        async getStands(store) {
            store.state.loading = true;
            var res = await axios.post('stand/list', {
                ...store.state.filter,
                skip: (store.state.filter.page - 1) * store.state.filter.take,
            });
            store.state.loading = false;
            return store.commit('setStands', res.data.data);
        },
        async getStandSaloons(store) {
            var res = await axios.post('stand/listsaloons', { skip: 0, take: 1000 });
            store.state.saloons = res.data.data.items;
        },

        async toggleStand(store, payload) {
            var res = await axios.post('Stand/toggleisactive', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async deleteStand(store, payload) {
            var res = await axios.post('stand/delete', {
                id: payload,
            });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async getStandSaloon(store, payload) {
            var res = await axios.post('stand/getsaloon', { id: payload });
            return res;
        },
        async standAddUpdate(store, payload) {
            var res = await axios.post('stand/addorupdate', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async standSaloonAddUpdate(store, payload) {
            var res = await axios.post('stand/addorupdatesaloon', payload);
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                Message.success(res.data.alert.message);
            }
            return res;
        },
        async deleteStandSaloon(store, payload) {
            var res = await axios.post('stand/deletesaloon', { id: payload });
            if (res.data.alert.hasError) {
                Message.error(res.data.alert.message);
            } else {
                store.state.saloons.splice(payload.index, 1);
                Message.success(res.data.alert.message);
            }
            return res;
        },
    },
    getters: {},
};
export default stands;


// WEBPACK FOOTER //
// ./src/store/stands.js